import styles from './ModalForm.module.css';

const ModalFormFooter = ({children}) => {
    return <div className={styles.modalFormFooter}>
        {children}
    </div>
};

export default ModalFormFooter;